/**
 * Logout.jsx - Quick logout page
 * Clears session and redirects to login
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../lib/supabase';
import { Loader2 } from 'lucide-react';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      console.log('[LOGOUT] Signing out...');
      
      try {
        await supabase.auth.signOut();
        console.log('[LOGOUT] Success');
      } catch (err) {
        console.error('[LOGOUT] Error:', err);
      }
      
      // Always redirect to login
      navigate('/login', { replace: true });
    };

    doLogout();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#b08b5c] mx-auto mb-4" />
        <p className="text-white/60">Disconnessione in corso...</p>
      </div>
    </div>
  );
};

export default Logout;
